var offline_mode = false; // true or false
var user_group_id = "4";
var user_group_name = "";
//var user_group_ua_property_id = "UA-601294-32"; // GA Linker - Variable
var user_group_ua_property_id = "UA-143763325-9"; // GA Linker - Variable - Cross Domain Tracking
var offline_url = "https://www.bigwphotos.com.au/pages/offline";
var reimagine_url = "https://4.app.fujifilmimagine.com/";
var poster_url = "https://4.app.fujifilmimagine.com/product/posters/";
var legacy_url = "https://fujifilmimagine.com/imagine/app.php?userGroupID=";

// GA Linker - Function. This gets the _ga url paramter for cross-domain tracking
function getGALinker() {
	var linkerParam;
	try {
		if(typeof ga != 'undefined' && user_group_ua_property_id) {
			// live property ID
			var propertyID = user_group_ua_property_id;
			var targetTracker;
			var trackers = ga.getAll();
			for (var i = 0; i<trackers.length; i++) {
				// tracker is not null and has get function
				if (trackers[i] && typeof trackers[i].get != 'undefined') {
					// tracker property ID matches live property ID
					if (trackers[i].get('trackingId') == propertyID) {
						// set as target tracker
						targetTracker = trackers[i];
					}
				}
			}
			if (targetTracker) {
				// get linker paramater for url;
				linkerParam = targetTracker.get('linkerParam');
			}
		} else {
			// ga not defined
		}
	} catch (e) {
		// script error
	}
	return linkerParam;
}

function fullWin(imagine_id) {
	var win;

	// GA Linker - Attempt to get _ga
	var gaLink = '';
	if (typeof getGALinker != 'undefined' ) {
		var gaLinkResult = getGALinker();
		if (gaLinkResult && gaLinkResult.indexOf('_ga') >= 0) {
			gaLink = '&'+gaLinkResult;
		}
	}

	// GA Linker - gaLink is added to redirect links
	if (offline_mode == true) {
		// offline mode
		win = window.location.href = offline_url;
	} else if (imagine_id == "#" || imagine_id == "" || imagine_id == undefined) {
		// imagine id hasn't been passed
		win = window.location.href = reimagine_url;
	} else if (imagine_id.slice(-1) == "#") {
		// product redirect for posters
		win = window.location.href = poster_url + imagine_id.slice(0,-1);
	} else {
		// product redirect for reimagine
		win = window.location.href = reimagine_url + "product-redirect?productId=" + imagine_id;
	}
	
	if (window.focus) {
		win.window.focus();
	}
}

function getProductPrice(imagine_id, shopify_id) {
	jQuery.ajax({
		url: "//rest.fujifilmimagine.com/api/product/" + imagine_id,
		dataType: "json",
		success: function(data, status, jqXHR) {
			if (typeof data.product[0] != undefined) {
				// api returned a result
				if (data.product[0].promo_price > 0 && data.product[0].price != data.product[0].promo_price) {
					// promo price exists
					$('#promo_' + shopify_id).show();
					$('#promo_' + shopify_id).html("&#36;" + data.product[0].price);
                    $('#promo_detail_' + shopify_id).show();
                    $('#promo_detail_' + shopify_id).html("&#36;" + data.product[0].price);
					$('#product_' + shopify_id).html("&#36;" + data.product[0].promo_price);
                    $('#product_' + shopify_id).addClass("on-sale-wrapper");
                    $('#product_detail_' + shopify_id).html("&#36;" + data.product[0].promo_price);
                    $('#product_detail_' + shopify_id).addClass("on-sale-wrapper");
                    $('#offer_badge_' + shopify_id).show();
                    $('#offer_detail_badge_' + shopify_id).show();
					$('#expires_' + shopify_id).show();
					$('#expires_' + shopify_id).html("Ends " + data.product[0].promo_ends);
					$('#expiry_detail_' + shopify_id).show();
					$('#expiry_detail_' + shopify_id).html("Ends " + data.product[0].promo_ends);
                    //$('#product_' + shopify_id).addClass("on-sale-wrapper");
                    //$('#price_data_' + shopify_id).addClass('on-sale-wrapper');
				} else {
					// no promo exists
					$('#promo_' + shopify_id).hide();
                    $('#promo_detail_' + shopify_id).hide();
					// check if product price exists before overwriting
					if (data.product[0].price > 0) {
						$('#product_' + shopify_id).html("&#36;" + data.product[0].price);
					}
					$('#offer_badge_' + shopify_id).hide();
                    $('#offer_detail_badge_' + shopify_id).hide();
                    $('#expires_' + shopify_id).hide();
                    $('#expiry_detail_' + shopify_id).hide();
                    $('#product_' + shopify_id).removeClass("on-sale-wrapper");
					//$('#price_data_' + shopify_id).removeClass('on-sale-wrapper');
				}
				sessionStorage.setItem("imagineid_" + imagine_id, JSON.stringify(data.product)); // stores product details to session for use by google tag manager
				//console.log(imagine_id + "," + shopify_id + "," + data.product[0].price + "," + data.product[0].promo_price);
			}
		},
		error: function(jqXHR, status) {
			//console.log(status);
		}
	});
}

function getDeliveryEstimate(postcode) {
	jQuery.ajax({
		url: "//rest.fujifilmimagine.com/api/delivery/" + postcode,
		dataType: "json",
		success: function(data, status, jqXHR) {
			if (typeof data.delivery[0] != undefined) {
				// api returned a result
                $('#delivery_form').hide();
                $('#delivery_submit').show();
                $('#delivery_region').html(data.delivery[0].suburb + " " + postcode + ", " + data.delivery[0].state);
                $('#delivery_instore').html(data.delivery[0].instore);
                $('#delivery_standard').html(data.delivery[0].standard);
                $('#delivery_express').html(data.delivery[0].express);
                $('#delivery').show();
				//console.log(imagine_id + "," + shopify_id + "," + data.product[0].price + "," + data.product[0].promo_price);
			}
		},
		error: function(jqXHR, status) {
			//console.log(status);
		}
	});
}

// Attempts to retrieve the product name from the session storage
function getImagineName(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].name;
	}
	return result;
}

// Attempts to retrieve the product category from the session storage
function getImagineCat(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].category;
	}
	return result;
}

// Attempts to retrieve and calculate the current price from the session storage
function getImaginePrice(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].price;
	}
	return result;
}

// Attempts to retrieve and calculate the current price from the session storage
function getImaginePromoPrice(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		if (pa[0].promo_price > 0) {
			result = pa[0].promo_price;
		} else {
			result = pa[0].price;
		}
	}
	return result;
}

// Attempts to determine if product is on promo from the session storage
function isOnPromo(imagine_id) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = 'False';
	} else {
		if (pa[0].promo_price > 0) {
			result = 'True';
		} else {
			result = 'False';
		}
	}
	return result;
}
